<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Duplicar orçamento modelo"
    type-modal="clone_quotation_model_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="clone()">

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>Modelo</label>
            <autocomplete
              ref="autocompleteModel"
              placeholder="Modelo"
              :items="models"
              item-show="model_name"
              :on-input="onInputModel"
              :on-select="setModel"
            ></autocomplete>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-3"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="clone()"
        class="btn btn-sm btn-primary"
      >Clonar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import { _LOAD_MODEL_, _OPEN_MODEL_MODAL_ } from '../QuotationModel';

export default {
  name: 'choose-quotation-model-modal',
  data() {
    return {
      loading: false,
      model_id: null,
    };
  },
  components: {
    Autocomplete,
    ModalTemplate,
  },
  computed: {
    models() {
      const { modelList } = this.$store.state.quotation;
      if (modelList && modelList.list.length) {
        return modelList.list;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getModelList',
    ]),
    close() {
      this.setToggle({ type: 'clone_quotation_model_modal', bool: false });
    },
    clone() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.duplicate(this.model_id)
        .then(response => {
          this.close();
          this.activeAlert({ message: 'Orçamento duplicado com sucesso', theme: 'success' });
          Events.$emit(_LOAD_MODEL_, response);
          this.$router.push(`/admin/orcamentos/${response.id}`);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    onInputModel(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        const params = {
          search: name,
          take: 10,
          page: 1,
          skip: 0,
        };
        this.getModelList(params);
      }, 500);
    },
    setModel(model) {
      this.model_id = model.id;
    },
  },
  mounted() {
    Events.$on(_OPEN_MODEL_MODAL_, () => {
      this.onInputModel('');
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
